import axios from '@_system/axios/axios.js'
export default {
	path: '/log',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	// init(data = {}) {
	// 	return new Promise((resolve,reject) => {
	// 		axios.get(this.path + 'Init', data, (res) => {
	// 			resolve(res.data)
	// 		},reject)
	// 	})
	// },		
}
